export const validateZipcode = (zipcode: string): boolean => /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zipcode);
export const onlyNumbersAndSpace = (input: string): boolean =>  /^[\d\s]*$/.test(input);
